/* Grid alignment Script */
{
  window.setGridHeight = (selector) => {
    const items = Array.from(document.querySelectorAll(selector));
    if (!items.length) return;

    // Reset min-heights first so we get accurate natural heights
    items.forEach(el => el.style.minHeight = '');

    const gridOffsets = items.map(el => {
      const row = el.closest('.grid__item') || 
                  el.closest('.carousel__item') || 
                  el.closest('.predictive-search__list-item');
      return {
        el,
        height: el.offsetHeight,
        top: row ? row.offsetTop : 0,
      };
    });

    // Group by row (same offsetTop) and equalise heights within each row
    const uniqueTops = [...new Set(gridOffsets.map(o => o.top))];
    uniqueTops.forEach(top => {
      const row = gridOffsets.filter(o => o.top === top);
      const maxH = Math.max(...row.map(o => o.height));
      row.forEach(o => { 
        o.el.style.boxSizing = 'border-box';
        o.el.style.minHeight = maxH + 'px'; 
      });
    });
  };

  window.setCategoriesCardHeight = () => {
    const cards = Array.from(document.querySelectorAll('.js-categories-card'));
    if (!cards.length) return;

    // Reset inline variable to calculate natural height
    cards.forEach(card => card.style.removeProperty('--card-min-height'));
    
    // Find the max natural height among all cards
    const maxH = Math.max(...cards.map(card => card.offsetHeight));
    
    // Set the max height as a CSS variable on each card
    cards.forEach(card => card.style.setProperty('--card-min-height', maxH + 'px'));
  };

  const matchHeightCallback = () => {
    window.setGridHeight('.js-product-title');
    window.setGridHeight('.js-product-information');
    window.setCategoriesCardHeight();
  };

  // Re-run on resize
  window.addEventListener('resize', matchHeightCallback);

  // Re-run whenever the predictive-search results are updated (dynamic AJAX injection)
  const observePredictiveSearch = () => {
    const resultsContainer =
      document.querySelector('.predictive-search') ||
      document.querySelector('[data-predictive-search]');

    if (resultsContainer) {
      new MutationObserver(() => {
        // Small frame delay so the browser has painted the new nodes
        requestAnimationFrame(matchHeightCallback);
      }).observe(resultsContainer, { childList: true, subtree: true });
    }
  };

  // Run once on load, then start observing
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      matchHeightCallback();
      observePredictiveSearch();
    });
  } else {
    matchHeightCallback();
    observePredictiveSearch();
  }
}


(() => {
  if (window.ThemeCustomJsLoaded) return;
  window.ThemeCustomJsLoaded = true;

// Hero Banner Drag / Swipe
(function initHeroBannerDrag() {

  function attachDrag(slideshowEl) {
    if (slideshowEl.dataset.dragInit) return;
    slideshowEl.dataset.dragInit = '1';

    const slider = slideshowEl.querySelector('[id^="Slider-"]');
    if (!slider) return;

    // Disable native dragging for images and links to prevent interference
    slider.querySelectorAll('img, a').forEach(el => {
      el.setAttribute('draggable', 'false');
    });

    let startX = 0, startY = 0, isDragging = false, didMove = false;

    function getX(e) { return (e.touches && e.touches[0]) ? e.touches[0].clientX : e.clientX; }
    function getY(e) { return (e.touches && e.touches[0]) ? e.touches[0].clientY : e.clientY; }

    function onStart(e) {
      if (e.type === 'mousedown' && e.button !== 0) return; // Only left click
      startX = getX(e);
      startY = getY(e);
      isDragging = true;
      didMove = false;
    }

    function onMove(e) {
      if (!isDragging) return;
      const dx = Math.abs(getX(e) - startX);
      const dy = Math.abs(getY(e) - startY);

      if (!didMove) {
        if (dy > dx && dy > 10) { isDragging = false; return; }
        if (dx > 10) { 
          didMove = true;
          slider.classList.add('is-dragging');
        }
      }

      if (didMove && e.cancelable) {
        e.preventDefault(); // Stop vertical scroll / link drag
      }
    }

    function onEnd(e) {
      if (!isDragging) return;
      isDragging = false;
      slider.classList.remove('is-dragging');
      
      // Resume autoplay if it was playing
      if (slideshowEl.play && slideshowEl.dataset.autoplay === 'true') {
          slideshowEl.play();
      }

      if (!didMove) return;

      const endX = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientX : e.clientX;
      const dx = endX - startX;

      if (Math.abs(dx) < 20) return;

      const slide = slider.querySelector('.slideshow__slide');
      if (!slide) return;
      
      const offset = slide.offsetWidth;
      const currentScroll = slider.scrollLeft;
      const totalSlides = slider.querySelectorAll('.slideshow__slide').length;
      
      let targetScroll;
      if (dx < 0) {
        // Swipe left → next
        const currentBatch = Math.floor((currentScroll + 20) / offset);
        targetScroll = (currentBatch + 1) * offset;
        if (targetScroll >= slider.scrollWidth - 20) targetScroll = 0;
      } else {
        // Swipe right → previous
        const currentBatch = Math.ceil((currentScroll - 20) / offset);
        targetScroll = (currentBatch - 1) * offset;
        if (targetScroll < -20) targetScroll = (totalSlides - 1) * offset;
      }

      const originalSnap = slider.style.scrollSnapType;
      slider.style.scrollSnapType = 'none';
      
      slider.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });

      setTimeout(() => {
        slider.style.scrollSnapType = originalSnap;
      }, 600);

      // Robust click suppression
      const suppress = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
      };
      slideshowEl.addEventListener('click', suppress, { capture: true, once: true });
      setTimeout(() => slideshowEl.removeEventListener('click', suppress, true), 300);
    }

    // Attach listeners
    slideshowEl.addEventListener('mousedown', onStart);
    window.addEventListener('mousemove', onMove, { passive: false });
    window.addEventListener('mouseup', onEnd);
    
    slideshowEl.addEventListener('touchstart', onStart, { passive: true });
    slideshowEl.addEventListener('touchmove', onMove, { passive: false });
    slideshowEl.addEventListener('touchend', onEnd);

    // Initial styles
    slider.style.cursor = 'grab';
    slider.style.userSelect = 'none';
    slider.style.webkitUserSelect = 'none';
  }

  function initAll() {
    document.querySelectorAll('.hero-banner-wrapper').forEach(attachDrag);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

// Wave Marquee
if(!customElements.get('wave-marquee')) {
  customElements.define('wave-marquee', class extends HTMLElement {
    constructor() { super(); this.d = parseFloat(this.dataset.duration) || 50; this.t = performance.now(); this.p = []; this.a = this.a.bind(this); this.c = this.c.bind(this); }
    connectedCallback() {
      const userAgent = navigator.userAgent.toLowerCase();
      const isSafari = userAgent.indexOf("safari") !== -1 && userAgent.indexOf("chrome") === -1;
      const isIOS = userAgent.match(/(iphone|ipod|ipad)/);
      const isMac = userAgent.indexOf("mac") !== -1;

      this.querySelectorAll('textPath').forEach(tp => {
        let el = document.querySelector(tp.getAttribute('href')) || this.querySelector(tp.getAttribute('href')), s = tp.closest('svg');
        this.p.push({ tp, s: (el?.getTotalLength?.() || s?.viewBox?.baseVal?.width || 1000) / this.d, x: 0, i: 0 });
        
        // Find parent text element to apply dy
        let parentText = tp.closest('text');
        if (parentText) {
          let dyVal = "0";
          if (isSafari) {
            if (isIOS) {
              dyVal = "4";
            } else if (isMac) {
              dyVal = "8";
            }
          }
          parentText.setAttribute('dy', dyVal);
        }
      });
      this.c(); window.addEventListener('resize', this.c);
      // Only start animation loop when animated class is present
      if (this.classList.contains('wave-marquee--animated')) {
        this.f = requestAnimationFrame(this.a);
      }
    }
    disconnectedCallback() { cancelAnimationFrame(this.f); window.removeEventListener('resize', this.c); }
    c() { this.p.forEach(d => { let i = d.tp.querySelector('.wave-text-instance'); d.i = i ? i.getComputedTextLength() : 0; }); }
    a(time) {
      let dt = time - this.t; this.t = time;
      if (dt > 0 && dt < 200) this.p.forEach(d => { d.x += (dt / 1000) * d.s; d.tp.setAttribute('startOffset', -(d.i > 0 ? d.x % d.i : d.x)); });
      this.f = requestAnimationFrame(this.a);
    }
  });
}

/**
 * Global Slider Controller
 * Handles Autoplay, Progress Indicators, and Navigation for various slider types.
 */
class GlobalSlider {
  constructor(element, options = {}) {
    this.container = element;
    this.list = element.querySelector('.slider-list') || element.querySelector('.slider') || element.querySelector('.categories-carousel-list') || element.querySelector('.prof-reviews-slider');
    this.slides = this.list ? Array.from(this.list.children) : [];
    this.dots = element.querySelectorAll('.progress-dot') || element.querySelectorAll('.categories-carousel-progress-dot');
    
    // Support for shared progress bar or multiple bars
    const foundBars = element.querySelectorAll('.progress-bar, .products-carousel-progress-bar, .prof-reviews-progress-bar');
    this.progressBars = options.progressBar ? [options.progressBar] : Array.from(foundBars);
    
    // Progress containers (the tracks) for click interaction
    this.progressContainers = Array.from(element.querySelectorAll('.progress-container, .products-carousel-progress, .prof-reviews-progress-container, .categories-carousel-progress'));
    
    this.prevBtns = element.querySelectorAll('.slider-button--prev, .custom-slider-button--prev');
    this.nextBtns = element.querySelectorAll('.slider-button--next, .custom-slider-button--next');
    
    // Fallback to section-level buttons if none found in container
    if (this.prevBtns.length === 0) {
      const sectionPrev = this.container.closest('section')?.querySelectorAll('.custom-slider-button--prev');
      if (sectionPrev) this.prevBtns = sectionPrev;
    }
    if (this.nextBtns.length === 0) {
      const sectionNext = this.container.closest('section')?.querySelectorAll('.custom-slider-button--next');
      if (sectionNext) this.nextBtns = sectionNext;
    }
    
    this.type = element.dataset.sliderType || 'scroll';
    this.autoplay = element.dataset.autoplay === 'true';
    this.autoplayDelay = parseInt(element.dataset.autoplayDelay) || 5000;
    this.autoplayInterval = null;
    this.currentIndex = 0;
    
    // Drag/Swipe state
    this.isDragging = false;
    this.startX = 0;
    this.scrollLeftStart = 0;
    this.dragThreshold = 5;
    this.hasMoved = false;
    this.lastX = 0;
    this.startTime = 0;

    this.init();
  }

  init() {
    if (!this.list && this.type !== 'fade') return;

    if (this.type === 'scroll' && this.list) {
      this.list.addEventListener('scroll', () => this.updateIndicators());
    }

    this.handlePrev = () => {
      if (this.container.offsetParent !== null) {
        this.scroll(-1);
      }
    };
    
    this.handleNext = () => {
      if (this.container.offsetParent !== null) {
        this.scroll(1);
      }
    };

    this.prevBtns.forEach(btn => btn.addEventListener('click', this.handlePrev));
    this.nextBtns.forEach(btn => btn.addEventListener('click', this.handleNext));

    if (this.autoplay) {
      this.startAutoplay();
      this.container.addEventListener('mouseenter', () => this.stopAutoplay());
      this.container.addEventListener('mouseleave', () => this.startAutoplay());
      if (this.list) {
        this.list.addEventListener('touchstart', () => this.stopAutoplay(), {passive: true});
        this.list.addEventListener('touchend', () => this.startAutoplay(), {passive: true});
      }
    }

    // Initialize drag functionality only for specific sections to prevent global jitter
    if (this.list && (this.list.classList.contains('prof-reviews-slider') || this.list.classList.contains('categories-carousel-list') || this.list.classList.contains('js-product-sabor__grid'))) {
      this.initDrag();
    }

    // Cancel scroll animations on any manual scroll start
    this.list?.addEventListener('touchstart', () => {
      if (this.scrollAnimation) cancelAnimationFrame(this.scrollAnimation);
    }, { passive: true });
    this.list?.addEventListener('mousedown', () => {
      if (this.scrollAnimation) cancelAnimationFrame(this.scrollAnimation);
    });

    window.addEventListener('resize', () => this.updateIndicators());
    this.initProgressBarClick();
    this.updateIndicators();
  }

  initProgressBarClick() {
    this.progressContainers.forEach(container => {
      container.style.cursor = 'pointer';
      container.addEventListener('click', (e) => {
        const rect = container.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const percentage = Math.max(0, Math.min(1, x / rect.width));

        if (this.type === 'fade') {
          const targetIndex = Math.round(percentage * (this.slides.length - 1));
          this.goToSlide(Math.max(0, targetIndex));
        } else if (this.list) {
          const maxScroll = this.list.scrollWidth - this.list.clientWidth;
          
          if (this.list.classList.contains('prof-reviews-slider') || this.list.classList.contains('categories-carousel-list')) {
            // Map 0-100% track length to 0-(count-1) slide indices
            const targetIndex = Math.round(percentage * (this.slides.length - 1));
            const computedStyle = window.getComputedStyle(this.list);
            const paddingOffset = parseInt(computedStyle.scrollPaddingLeft) || 0;
            
            let targetLeft = this.slides[Math.max(0, targetIndex)].offsetLeft - paddingOffset;
            
            // Centered snapping for categories
            if (this.list.classList.contains('categories-carousel-list')) {
              targetLeft = this.slides[Math.max(0, targetIndex)].offsetLeft - (this.list.clientWidth / 2) + (this.slides[Math.max(0, targetIndex)].clientWidth / 2);
            }
            
            const maxScroll = this.list.scrollWidth - this.list.clientWidth;
            this.smoothScrollTo(this.list, Math.max(0, Math.min(targetLeft, maxScroll)), 600);
          } else {
            // General scroll mapping: Map 0-100% click to 0-maxScroll
            const targetLeft = percentage * maxScroll;
            this.smoothScrollTo(this.list, Math.max(0, targetLeft), 600);
          }
        }
      });
    });
  }

  scroll(direction) {
    if (this.type === 'fade') {
      let nextIndex = this.currentIndex + direction;
      if (nextIndex >= this.slides.length) nextIndex = 0;
      if (nextIndex < 0) nextIndex = this.slides.length - 1;
      this.goToSlide(nextIndex);
      return;
    }

    const items = this.list ? Array.from(this.list.children) : [];
    if (!items.length) return;
    
    const currentScroll = this.list.scrollLeft;
    const computedStyle = window.getComputedStyle(this.list);
    const paddingOffset = parseInt(computedStyle.scrollPaddingLeft) || 0;
    
    let currentIndex = 0;
    let minDiff = Infinity;
    
    const containerRect = this.list.getBoundingClientRect();
    
    // Find closest item factoring in the padding offset
    items.forEach((item, index) => {
      const itemRect = item.getBoundingClientRect();
      const itemOffset = itemRect.left - containerRect.left + currentScroll;
      let itemIdealScroll = itemOffset - paddingOffset;
      
      if (this.list.classList.contains('categories-carousel-list')) {
        itemIdealScroll = itemOffset - (this.list.clientWidth / 2) + (item.clientWidth / 2);
      }
      
      const diff = Math.abs(itemIdealScroll - currentScroll);
      if (diff < minDiff) {
        minDiff = diff;
        currentIndex = index;
      }
    });

    let targetIndex = currentIndex;
    const maxScroll = this.list.scrollWidth - this.list.clientWidth;

    if (direction > 0) {
      // Next: find first item with greater offset
      for (let i = currentIndex + 1; i < items.length; i++) {
        const itemRect = items[i].getBoundingClientRect();
        const itemOffset = itemRect.left - containerRect.left + currentScroll;
        const currentItemRect = items[currentIndex].getBoundingClientRect();
        const currentItemOffset = currentItemRect.left - containerRect.left + currentScroll;

        if (itemOffset > currentItemOffset + 2) {
          targetIndex = i;
          break;
        }
      }
      if (targetIndex === currentIndex && currentScroll >= maxScroll - 10 && this.autoplay) {
         targetIndex = 0;
      }
    } else {
      // Prev: find first item with smaller offset
      for (let i = currentIndex - 1; i >= 0; i--) {
        const itemRect = items[i].getBoundingClientRect();
        const itemOffset = itemRect.left - containerRect.left + currentScroll;
        const currentItemRect = items[currentIndex].getBoundingClientRect();
        const currentItemOffset = currentItemRect.left - containerRect.left + currentScroll;

        if (itemOffset < currentItemOffset - 2) {
          targetIndex = i;
          break;
        }
      }
      if (targetIndex === currentIndex && currentScroll <= 10 && this.autoplay) {
         targetIndex = items.length - 1;
      }
    }

    const targetItemRect = items[targetIndex].getBoundingClientRect();
    const targetItemOffset = targetItemRect.left - containerRect.left + currentScroll;
    let targetLeft = targetItemOffset - paddingOffset;
    
    if (this.list.classList.contains('categories-carousel-list')) {
      targetLeft = targetItemOffset - (this.list.clientWidth / 2) + (items[targetIndex].clientWidth / 2);
    }
    
    if (this.list.classList.contains('categories-carousel-list')) {
      const maxScroll = this.list.scrollWidth - this.list.clientWidth;
      targetLeft = Math.max(0, Math.min(targetLeft, maxScroll));
      this.list.style.scrollSnapType = 'none';
      this.list.scrollTo({ left: targetLeft, behavior: 'smooth' });
      setTimeout(() => {
        if (this.list) this.list.style.scrollSnapType = '';
      }, 600);
    } else {
      this.smoothScrollTo(this.list, targetLeft, 600);
    }
  }

  smoothScrollTo(element, targetX, duration) {
    if (this.scrollAnimation) cancelAnimationFrame(this.scrollAnimation);
    const startX = element.scrollLeft;
    const distance = targetX - startX;
    const startTime = performance.now();

    element.style.scrollBehavior = 'auto';
    element.style.scrollSnapType = 'none';

    // Ease In Out Quad transition for a really smooth sliding feel
    const easeInOutQuad = (t, b, c, d) => {
      t /= d / 2;
      if (t < 1) return (c / 2) * t * t + b;
      t--;
      return (-c / 2) * (t * (t - 2) - 1) + b;
    };

    const animation = (currentTime) => {
      const timeElapsed = currentTime - startTime;
      const nextX = easeInOutQuad(timeElapsed, startX, distance, duration);
      
      element.scrollLeft = nextX;
      
      if (timeElapsed < duration) {
        this.scrollAnimation = requestAnimationFrame(animation);
      } else {
        element.scrollLeft = targetX;
        element.style.scrollBehavior = '';
        element.style.scrollSnapType = '';
        this.scrollAnimation = null;
      }
    };

    this.scrollAnimation = requestAnimationFrame(animation);
  }

  goToSlide(index) {
    if (this.type === 'fade' && this.slides[index]) {
      this.slides[this.currentIndex].classList.remove('is-active', 'active');
      this.currentIndex = index;
      this.slides[this.currentIndex].classList.add('is-active', 'active');
      this.updateIndicators();
    }
  }

  updateIndicators() {
    if (this.progressBars.length > 0 && this.slides.length > 0) {
      if (this.type === 'scroll' && this.list) {
        const total = this.list.scrollWidth;
        const visible = this.list.clientWidth;
        const maxScroll = total - visible;
        
        let progress = '0%';
        if (maxScroll > 0) {
           // Visual Progress: minWidth (at 0 scroll) to 100% (at max scroll)
           const minWidth = (visible / total) * 100;
           const scrollPercent = this.list.scrollLeft / maxScroll;
           progress = (minWidth + (scrollPercent * (100 - minWidth))) + '%';
        } else {
           progress = '100%';
        }
        this.progressBars.forEach(bar => bar.style.width = progress);
      } else {
        // Fade or single-slide steps: Slide 1 starts at (1 / total)
        const progress = ((this.currentIndex + 1) / this.slides.length * 100) + '%';
        this.progressBars.forEach(bar => bar.style.width = progress);
      }
    }

    if (this.dots.length > 0) {
      let activeIndex = this.currentIndex;
      if (this.type === 'scroll' && this.list) {
        const itemWidth = this.slides[0].offsetWidth;
        if (itemWidth > 0) {
          activeIndex = Math.max(0, Math.min(Math.round(this.list.scrollLeft / itemWidth), this.dots.length - 1));
        }
      }
      this.dots.forEach((dot, idx) => dot.classList.toggle('active', idx === activeIndex));
    }
    
    if (this.type === 'scroll' && this.list) {
      let maxScroll = this.list.scrollWidth - this.list.clientWidth;
      if (maxScroll <= 1) {
        this.prevBtns.forEach(btn => {
          btn.setAttribute('disabled', 'disabled');
          btn.parentElement.classList.add('is-hidden');
        });
        this.nextBtns.forEach(btn => {
          btn.setAttribute('disabled', 'disabled');
          btn.parentElement.classList.add('is-hidden');
        });
      } else {
        if (this.prevBtns.length > 0) {
          if (this.list.scrollLeft <= 5) {
            this.prevBtns.forEach(btn => btn.setAttribute('disabled', 'disabled'));
          } else {
            this.prevBtns.forEach(btn => {
              btn.removeAttribute('disabled');
              btn.parentElement.classList.remove('is-hidden');
            });
          }
        }
        if (this.nextBtns.length > 0) {
          if (this.list.scrollLeft >= maxScroll - 5) {
            this.nextBtns.forEach(btn => btn.setAttribute('disabled', 'disabled'));
          } else {
            this.nextBtns.forEach(btn => {
              btn.removeAttribute('disabled');
              btn.parentElement.classList.remove('is-hidden');
            });
          }
        }
      }
    }
  }

  startAutoplay() {
    this.stopAutoplay();
    this.autoplayInterval = setInterval(() => this.scroll(1), this.autoplayDelay);
  }

  stopAutoplay() {
    if (this.autoplayInterval) clearInterval(this.autoplayInterval);
  }

  initDrag() {
    const list = this.list;
    let dragTargetX = 0;
    
    const render = () => {
      if (!this.isDragging) return;
      this.dragRaf = requestAnimationFrame(render);
    };

    const onStart = (e) => {
      if (e.type === 'mousedown' && e.button !== 0) return;

      this.isDragging = true;
      this.hasMoved = false;
      this.isVerticalScroll = false;
      
      // Robust coordinate retrieval for mobile
      const touch = e.touches ? e.touches[0] : null;
      this.startX = touch ? touch.pageX : e.pageX;
      this.startY = touch ? touch.pageY : e.pageY;
      
      dragTargetX = this.startX;
      this.scrollLeftStart = list.scrollLeft;
      this.startTime = Date.now();
      
      // Disable snapping immediately on start to prevent the browser from fighting the JS
      list.style.scrollBehavior = 'auto';
      list.style.scrollSnapType = 'none';
      if (touch) list.classList.add('is-dragging'); 
      
      this.stopAutoplay();
      this.dragRaf = requestAnimationFrame(render);
    };

    const onMove = (e) => {
      if (!this.isDragging || this.isVerticalScroll) return;
      
      const touch = e.touches ? e.touches[0] : null;
      const x = touch ? touch.pageX : e.pageX;
      const y = touch ? touch.pageY : e.pageY;
      
      const walk = (x - this.startX); 
      const walkY = (y - this.startY);

      // Axis detection: only kill drag if vertical movement is clearly dominant
      if (!this.hasMoved && Math.abs(walkY) > Math.abs(walk) * 2.0 && Math.abs(walkY) > 10) {
        this.isVerticalScroll = true;
        this.isDragging = false;
        list.classList.remove('is-dragging');
        cancelAnimationFrame(this.dragRaf);
        return;
      }

      dragTargetX = x;
      
      if (!this.hasMoved && Math.abs(walk) > this.dragThreshold) {
        this.hasMoved = true;
        list.classList.add('is-dragging');
        // If we are dragging, we definitely want to prevent default horizontal scroll
        if (e.cancelable) e.preventDefault();
      }

      if (this.hasMoved) {
        if (e.cancelable) e.preventDefault();
        // Apply scroll change directly in onMove for 1:1 responsiveness on mobile
        list.scrollLeft = this.scrollLeftStart - walk;
      }
      
      this.lastX = x;
    };

    const onEnd = (e) => {
      if (!this.isDragging) return;
      
      this.isDragging = false;
      cancelAnimationFrame(this.dragRaf);
      list.classList.remove('is-dragging');
      
      list.style.scrollBehavior = '';
      if (!list.classList.contains('categories-carousel-list')) {
        list.style.scrollSnapType = '';
      }

      if (this.autoplay) this.startAutoplay();

      if (!this.hasMoved) {
        if (list.classList.contains('categories-carousel-list')) {
          list.style.scrollSnapType = '';
        }
        return;
      }

      const x = (e.pageX || (e.changedTouches ? e.changedTouches[0].pageX : this.lastX));
      const diff = x - this.startX;

      // Snap to nearest item after drag completes, taking momentum into account
      this.snapToItem(diff);
    };

    // Mouse events
    list.addEventListener('mousedown', onStart);
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onEnd);
    list.addEventListener('mouseleave', () => {
      if (this.isDragging) onEnd({ pageX: this.lastX });
    });

    // Touch events
    list.addEventListener('touchstart', onStart, { passive: true });
    list.addEventListener('touchmove', onMove, { passive: false });
    list.addEventListener('touchend', onEnd);

    // Prevent clicks during drag
    list.addEventListener('click', (e) => {
      if (this.hasMoved) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    // Prevent native drag events (e.g., images) from interrupting custom drag
    list.addEventListener('dragstart', (e) => e.preventDefault());
  }

  snapToItem(dragDiff = 0) {
    if (this.type !== 'scroll') return;
    const items = this.list ? Array.from(this.list.children) : [];
    if (!items.length) return;
    
    const currentScroll = this.list.scrollLeft;
    const computedStyle = window.getComputedStyle(this.list);
    const paddingOffset = parseInt(computedStyle.scrollPaddingLeft) || 0;
    
    // Find the item that was at the start of the drag
    let startIndex = 0;
    let startMinDiff = Infinity;
    items.forEach((item, index) => {
      let itemIdealScroll = item.offsetLeft - paddingOffset;
      if (this.list.classList.contains('categories-carousel-list')) {
        itemIdealScroll = item.offsetLeft - (this.list.clientWidth / 2) + (item.clientWidth / 2);
      }
      const diff = Math.abs(itemIdealScroll - this.scrollLeftStart);
      if (diff < startMinDiff) {
        startMinDiff = diff;
        startIndex = index;
      }
    });

    // Find closest item to the FINAL scroll position
    let closestIndex = 0;
    let minDiff = Infinity;
    items.forEach((item, index) => {
      let itemIdealScroll = item.offsetLeft - paddingOffset;
      if (this.list.classList.contains('categories-carousel-list')) {
        itemIdealScroll = item.offsetLeft - (this.list.clientWidth / 2) + (item.clientWidth / 2);
      }
      const diff = Math.abs(itemIdealScroll - currentScroll);
      if (diff < minDiff) {
        minDiff = diff;
        closestIndex = index;
      }
    });

    let targetIndex = closestIndex;
    const threshold = 40; 
    
    // If it was a fast flick, override the closest item to move in the flick direction
    if (dragDiff < -threshold && targetIndex <= startIndex) {
      for (let i = startIndex + 1; i < items.length; i++) {
        if (items[i].offsetLeft > items[startIndex].offsetLeft + 2) {
          targetIndex = i;
          break;
        }
      }
    } else if (dragDiff > threshold && targetIndex >= startIndex) {
      for (let i = startIndex - 1; i >= 0; i--) {
        if (items[i].offsetLeft < items[startIndex].offsetLeft - 2) {
          targetIndex = i;
          break;
        }
      }
    }
    
    targetIndex = Math.max(0, Math.min(targetIndex, items.length - 1));
    let targetLeft = items[targetIndex].offsetLeft - paddingOffset;
    if (this.list.classList.contains('categories-carousel-list')) {
      targetLeft = items[targetIndex].offsetLeft - (this.list.clientWidth / 2) + (items[targetIndex].clientWidth / 2);
    }
    
    if (this.list.classList.contains('categories-carousel-list')) {
      const maxScroll = this.list.scrollWidth - this.list.clientWidth;
      targetLeft = Math.max(0, Math.min(targetLeft, maxScroll));
      this.list.style.scrollSnapType = 'none';
      this.list.scrollTo({ left: targetLeft, behavior: 'smooth' });
      setTimeout(() => {
        if (this.list) this.list.style.scrollSnapType = '';
      }, 600);
    } else {
      this.smoothScrollTo(this.list, targetLeft, 500);
    }
  }
}

class TabbedSlider {
  constructor(section) {
    this.section = section;
    this.tabButtons = section.querySelectorAll('.products-carousel-tabs__button');
    this.panels = section.querySelectorAll('.products-carousel-panel');
    this.progressBar = section.querySelector('.progress-bar');
    this.sliders = new Map();
    this.activeSlider = null;
    this.init();
  }

  init() {
    this.tabButtons.forEach(btn => {
      btn.addEventListener('click', () => this.activateTab(btn, btn.getAttribute('data-target')));
    });

    const initialActive = this.section.querySelector('.products-carousel-panel.active');
    if (initialActive) {
      this.activeSlider = new GlobalSlider(initialActive, { progressBar: this.progressBar });
      this.sliders.set(initialActive.id, this.activeSlider);
    }
  }

  activateTab(button, targetId) {
    this.tabButtons.forEach(b => b.classList.remove('active'));
    this.panels.forEach(p => {
      p.classList.remove('active');
      if (p.id === targetId) {
        p.classList.add('active');
        if (this.activeSlider) this.activeSlider.stopAutoplay();
        
        let slider = this.sliders.get(targetId);
        if (!slider) {
          slider = new GlobalSlider(p, { progressBar: this.progressBar });
          this.sliders.set(targetId, slider);
        } else {
          slider.updateIndicators();
          if (slider.autoplay) slider.startAutoplay();
        }
        this.activeSlider = slider;
      }
    });
    button.classList.add('active');
    if (window.updateCardHeights) window.updateCardHeights();
  }
}

// Initialization for all relevant sections
const initGlobalSliders = () => {
  // Generic Sliders
  document.querySelectorAll('.categories-carousel-wrapper, .prof-reviews-section').forEach(el => {
    if (el.dataset.sliderInitialized) return;
    new GlobalSlider(el);
    el.dataset.sliderInitialized = 'true';
  });

  // Tabbed Sliders (Products Carousel)
  document.querySelectorAll('.products-carousel').forEach(el => {
    if (el.dataset.sliderInitialized) return;
    new TabbedSlider(el);
    el.dataset.sliderInitialized = 'true';
  });
};

document.addEventListener('DOMContentLoaded', initGlobalSliders);
document.addEventListener('shopify:section:load', initGlobalSliders);

  // Footer Accordion (Simple enough to keep as is, or move to its own controller)
  const footerDetails = document.querySelectorAll('.footer-block__details');
  if (footerDetails.length > 0) {
    const mediaQuery = window.matchMedia('(min-width: 750px)');
    const handleFooterAccordion = () => {
      footerDetails.forEach(details => {
        if (mediaQuery.matches) details.setAttribute('open', '');
        else details.removeAttribute('open');
      });
    };
    handleFooterAccordion();
    mediaQuery.addEventListener('change', handleFooterAccordion);
  }

  // Products by Age (Kept separate as it has complex cross-linking and mobile behaviors)
  document.querySelectorAll('.products-by-age-section').forEach(function (section) {
    var dots   = Array.from(section.querySelectorAll('.products-by-age__dot'));
    var slides = Array.from(section.querySelectorAll('.products-by-age__slide'));
    var nav = section.querySelector('.products-by-age__nav');
    var slider = section.querySelector('.products-by-age__slider');

    if (!dots.length || !slides.length || !slider) return;

    function isMobile() { return window.innerWidth < 750; }

    var prevIndex = 0;
    var isClickScrolling = false;

    function setActiveDot(index) {
      dots.forEach(function (d, i) {
        d.classList.toggle('active', i === index);
        d.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      if (isMobile() && nav && dots[index]) {
        var dot = dots[index];
        var targetLeft = dot.offsetLeft - 8;

        if (index < prevIndex) {
          targetLeft = (dot.offsetLeft + dot.offsetWidth) - nav.clientWidth + 8;
          if (targetLeft < 0) targetLeft = 0;
        }

        nav.scrollTo({
          left: targetLeft,
          behavior: 'smooth'
        });
      }
      prevIndex = index;
    }

    function activateSlide(index) {
      slides.forEach(function (s, i) { s.classList.toggle('active', i === index); });
      setActiveDot(index);
    }

    function scrollToSlide(index) {
      var slide = slides[index];
      if (!slide) return;
      isClickScrolling = true;
      slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      setActiveDot(index);
      
      // Let the smooth scroll finish before re-enabling observer
      setTimeout(function() {
        isClickScrolling = false;
      }, 600);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        var index = parseInt(this.getAttribute('data-index'), 10);
        if (isMobile()) scrollToSlide(index);
        else activateSlide(index);
      });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (!isMobile() || isClickScrolling) return;
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var index = slides.indexOf(entry.target);
            if (index !== -1) setActiveDot(index);
          }
        });
      }, { root: slider, threshold: 0.6 });
      slides.forEach(function (slide) { observer.observe(slide); });
    }
  });
  
  window.GlobalSlider = GlobalSlider;
  window.TabbedSlider = TabbedSlider;
})();

// Browser & OS Detection
(function () {
  const userAgent = navigator.userAgent.toLowerCase();
  const body = document.body;

  // OS Detection Hierarchy
  let detectedOS = '';

  if (/iphone|ipad|ipod/.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
    detectedOS = 'ios';
  } else if (/macintosh|mac os x/.test(userAgent) || navigator.platform === 'MacIntel') {
    detectedOS = 'mac';
  } else if (/android/.test(userAgent)) {
    detectedOS = 'android';
  } else if (/win/.test(userAgent)) {
    detectedOS = 'windows';
  } else if (/linux/.test(userAgent)) {
    detectedOS = 'linux';
  }

  if (detectedOS) body.classList.add(detectedOS);

  // Browser Detection
  if (userAgent.indexOf("chrome") !== -1 && userAgent.indexOf("edg") === -1) {
    body.classList.add("chrome");
  } else if (userAgent.indexOf("safari") !== -1 && userAgent.indexOf("chrome") === -1) {
    body.classList.add("safari");
  } else if (userAgent.indexOf("firefox") !== -1) {
    body.classList.add("firefox");
  } else if (userAgent.indexOf("edg") !== -1) {
    body.classList.add("edge");
  }
})();

// related product block js
(function() {
  const initBlockSlider = () => {
    const panel = document.querySelector('.js-related-product-slider');
    if (!panel) return;
    const container = panel.closest('.js-related-products');
    if (container && window.GlobalSlider && !container.dataset.sliderInitialized) {
      new window.GlobalSlider(container);
      container.dataset.sliderInitialized = 'true';
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlockSlider);
  } else {
    initBlockSlider();
  }
  document.addEventListener('shopify:section:load', initBlockSlider);
})();

// Flavor products grid element
if (!customElements.get('product-sabor-grid')) {
  customElements.define('product-sabor-grid', class extends HTMLElement {
    connectedCallback() {
      this.init();
    }
    
    init() {
      // Small delay to ensure GlobalSlider is available and DOM is fully ready
      setTimeout(() => {
        if (window.GlobalSlider) {
          this.slider = new window.GlobalSlider(this);
        }
      }, 100);
      // One row when every flavour fits in the width; otherwise the two-row layout.
      // custom.js loads in the head, so the tiles may not be parsed yet: wait for the page.
      const watch = () => {
        this.grid = this.querySelector('.product-sabor__grid');
        if (this.grid && window.ResizeObserver) {
          new ResizeObserver(() => this.fitRows()).observe(this.grid);
        }
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
      else watch();
    }

    fitRows() {
      const items = this.grid.querySelectorAll('.product-sabor-item');
      if (!items.length) return;
      const style = getComputedStyle(this.grid);
      const room = this.grid.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
      const gap = parseFloat(style.columnGap) || 0;
      // Measure the tile at its normal size; in one row tiles stretch, so keep the last normal size
      if (!this.tileWidth || !this.grid.classList.contains('is-one-row')) this.tileWidth = items[0].offsetWidth;
      // tiles may shrink to 85% of their normal size to fit in one row
      const need = items.length * this.tileWidth * 0.85 + (items.length - 1) * gap;
      this.grid.classList.toggle('is-one-row', need <= room);
      // One row fills the width like the buy button: at least 4 columns so 2–3 flavours don't get huge
      this.grid.style.setProperty('--sabor-cols', Math.max(items.length, 4));
    }
  });
}

  // js/custom-element/section/cart/free-shipping-bar.js
    var FreeShippingBar = class extends HTMLElement {
        connectedCallback() {
            document.documentElement.addEventListener(
                "cart:updated",
                this._onCartUpdated.bind(this)
            );
        }
        get threshold() {
            return parseFloat(this.getAttribute("threshold"));
        }
        _onCartUpdated(event) {
            this.style.setProperty(
                "--progress",
                Math.min(
                    parseFloat(event.detail["cart"]["total_price"]) /
                    this.threshold,
                    1
                )
            );
        }
    };
    if (!window.customElements.get("free-shipping-bar")) {
      window.customElements.define("free-shipping-bar", FreeShippingBar);
    }

/* Card product height calculation script */
(function() {
  window.updateCardHeights = () => {
    const cards = document.querySelectorAll('.js-card-wrapper');
    cards.forEach(card => {
      const inner = card.querySelector('.js-card-inner');
      if (inner) {
        card.style.setProperty('--card-inner-height', `${inner.offsetHeight}px`);
      }

      const quantityWrapper = card.querySelector('.js-quantity-wrapper');
      if (quantityWrapper) {
        card.style.setProperty('--quantity-wrapper-height', `${quantityWrapper.offsetHeight}px`);
        
        // Add ResizeObserver to update height when content changes (e.g. subscription widget)
        if (window.ResizeObserver && !quantityWrapper.dataset.heightObserved) {
          const observer = new ResizeObserver(() => {
            card.style.setProperty('--quantity-wrapper-height', `${quantityWrapper.offsetHeight}px`);
          });
          observer.observe(quantityWrapper);
          quantityWrapper.dataset.heightObserved = 'true';
        }
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.updateCardHeights);
  } else {
    window.updateCardHeights();
  }

  window.addEventListener('resize', window.updateCardHeights);
  document.addEventListener('shopify:section:load', window.updateCardHeights);
})();

{
    let page = window.location.href;

    if (page.includes('/products')) {      
      const intervalId = setInterval(() => {
        let formEmbed = document.querySelector('recharge-subscription-widget');
        let formEmbed_options = formEmbed && formEmbed.shadowRoot ? formEmbed.shadowRoot.querySelector('rc-selling-plans') : null;
        let rc_benefits = formEmbed && formEmbed.shadowRoot ? formEmbed.shadowRoot.querySelector('rc-benefits') : null;
        let rc_learn_more = formEmbed && formEmbed.shadowRoot ? formEmbed.shadowRoot.querySelector('rc-learn-more') : null;
        
        if (!formEmbed || !formEmbed.shadowRoot) return;
        
        let styleContainer = document.createElement('link');
        styleContainer.id = "style-link";
        styleContainer.rel = "stylesheet";
        styleContainer.href = shadowrootsubscriptionCss;
        styleContainer.type = "text/css";
        
        if (!formEmbed.shadowRoot.querySelector('#style-link')) {
            formEmbed.shadowRoot.appendChild(styleContainer);
        }
        
        if (formEmbed_options && formEmbed_options.shadowRoot && !formEmbed_options.shadowRoot.querySelector('#style-link')) {
            formEmbed_options.shadowRoot.appendChild(styleContainer.cloneNode(true));
        }
        if (rc_benefits && rc_benefits.shadowRoot && !rc_benefits.shadowRoot.querySelector('#style-link')) {
          rc_benefits.shadowRoot.appendChild(styleContainer.cloneNode(true));
        }
        if (rc_learn_more && rc_learn_more.shadowRoot && !rc_learn_more.shadowRoot.querySelector('#style-link')) {
          rc_learn_more.shadowRoot.appendChild(styleContainer.cloneNode(true));
        }
      }, 500);
        
      setTimeout(() => {
        clearInterval(intervalId);
      }, 10000);
    }
}

(() => {
  const initializedSections = new WeakSet();

  const initSlideshowShare = (section) => {
    if (!section || initializedSections.has(section)) return;

    const slideshowComponent = section.querySelector('slideshow-component');
    if (!slideshowComponent) return;
    initializedSections.add(section);

    const hidePopover = (popover) => {
      if (!popover) return;
      popover.hidden = true;
      popover.classList.remove('is-open');
    };

    const hideAll = () => {
      section.querySelectorAll('[data-share-popover].is-open').forEach((popover) => hidePopover(popover));
    };

    const updateLinks = (popover, shareUrl) => {
      const encodedUrl = encodeURIComponent(shareUrl);
      const shareMap = {
        whatsapp: `https://api.whatsapp.com/send?text=${encodedUrl}`,
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
        x: `https://twitter.com/intent/tweet?url=${encodedUrl}`,
        email: `mailto:?body=${encodedUrl}`,
        linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`
      };

      Object.entries(shareMap).forEach(([target, href]) => {
        const anchor = popover.querySelector(`[data-share-target="${target}"]`);
        if (!anchor) return;
        const customLink = anchor.dataset.shareCustomLink;
        anchor.href = customLink && customLink.trim() !== '' ? customLink : href;
      });
    };

    section.querySelectorAll('.banner__podcast-icons').forEach((iconsWrap) => {
      const toggleBtn = iconsWrap.querySelector('[data-share-toggle]');
      const popover = iconsWrap.querySelector('[data-share-popover]');
      const urlInput = popover?.querySelector('[data-share-input]');
      const copyBtn = popover?.querySelector('[data-share-copy]');
      const closeBtn = popover?.querySelector('[data-share-close]');
      if (!toggleBtn || !popover || !urlInput) return;

      updateLinks(popover, urlInput.value || window.location.href);

      toggleBtn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const isOpen = popover.classList.contains('is-open');
        hideAll();
        if (!isOpen) {
          popover.hidden = false;
          popover.classList.add('is-open');
        }
      });

      closeBtn?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        hidePopover(popover);
      });

      copyBtn?.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();
        try {
          await navigator.clipboard.writeText(urlInput.value);
          copyBtn.textContent = 'Copiado';
          setTimeout(() => {
            copyBtn.textContent = 'Copiar';
          }, 1800);
        } catch (error) {
          urlInput.focus();
          urlInput.select();
        }
      });
    });

    document.addEventListener('click', (event) => {
      const clickedShareUI = event.target.closest('[data-share-popover], [data-share-toggle]');
      if (!clickedShareUI) hideAll();
    });

    window.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') hideAll();
    });
  };

  const initAll = () => {
    document.querySelectorAll('.slideshow-section').forEach((section) => initSlideshowShare(section));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initSlideshowShare(event.target);
  });
})();
// Background videos (snippets/lazy-video.liquid): nothing downloads until a video is on screen, and it
// pauses when scrolled away. Copies hidden at this screen size (the desktop video on phones) and hero
// slides that aren't showing never start.
(function () {
  const canPlay = (video) => video.getClientRects().length > 0 && !video.closest('[aria-hidden="true"]');
  window.smileatPlayLazyVideo = (video) => {
    if (video.inView && canPlay(video)) video.play().catch(() => {});
  };
  const observer = window.IntersectionObserver && new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      target.inView = isIntersecting;
      if (isIntersecting) window.smileatPlayLazyVideo(target);
      else target.pause();
    });
  }, { rootMargin: '200px 0px' });
  const watch = (root) => {
    root.querySelectorAll('video[data-lazy-autoplay]').forEach((video) => {
      if (observer) observer.observe(video);
      else {
        video.inView = true;
        window.smileatPlayLazyVideo(video);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => watch(document));
  else watch(document);
  document.addEventListener('shopify:section:load', (event) => watch(event.target));
})();
